import type { FC, PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';

import { TextButton } from '@xing-com/button';
import { GridItem } from '@xing-com/grid';
import { IconArrowRight, IconArrowLeft } from '@xing-com/icons';
import { CenterContainer } from '@xing-com/platform-layout-view-wrapper';
import { Headline, Meta } from '@xing-com/typography';

import * as Styled from './section-slider-container.styles';

type SectionSliderContainerProps = {
  title: string;
  subtitle?: string;
  onArrowLeftClick?: () => void;
  onArrowRightClick?: () => void;
};

// This SectionSliderContainer will be modified once the Slider Component is integrated
export const SectionSliderContainer: FC<
  PropsWithChildren<SectionSliderContainerProps>
> = ({
  title,
  subtitle,
  children,
  onArrowLeftClick,
  onArrowRightClick,
  ...res
}) => {
  return (
    <CenterContainer {...res}>
      <Styled.SectionGridContainer variant="FullSize">
        <GridItem span={12} spanLarge={10}>
          <Headline noMargin size="xxxlarge">
            <FormattedMessage id={title} />
          </Headline>
          {subtitle && (
            <Meta noMargin size="large">
              <FormattedMessage id={subtitle} />
            </Meta>
          )}
        </GridItem>
        <Styled.ButtonContainer span={12} spanLarge={2}>
          <TextButton
            onClick={onArrowLeftClick}
            fontWeight="regular"
            icon={IconArrowLeft}
            iconAfter
            size="large"
          />

          <TextButton
            onClick={onArrowRightClick}
            fontWeight="regular"
            icon={IconArrowRight}
            iconAfter
            size="large"
          />
        </Styled.ButtonContainer>
        <GridItem span={12}>
          <Styled.Slider>{children}</Styled.Slider>
        </GridItem>
      </Styled.SectionGridContainer>
    </CenterContainer>
  );
};
